export default __webpack_public_path__ + "static/product-innovation-da88d31d412c907bd1b01c920f33434a.jpg";